import { reaction } from 'mobx';
import { getEnv, types, flow, addDisposer } from 'mobx-state-tree';
import omit from 'lodash/omit';

import Pages from '../definitions/Pages';


const ProfileDetails = types
    .model('Profile Details', {
        id: types.optional(types.identifier, Pages.profileDetails.id),

        hasSuceeded: false,
        hasError: false,
    })
    .views(self => ({
        get context() {
            return getEnv(self);
        },
        get viewStore() {
            return self.context.viewStore;
        },
        get sessionStore() {
            return self.context.sessionStore;
        },
        get values() {
            const location = self.sessionStore.profile.homeAddress
                ? {
                    name: self.sessionStore.profile.homeAddress.city,
                    province: {
                        code: self.sessionStore.profile.homeAddress.province,
                    },
                }
                : undefined;

            return {
                ...self.sessionStore.profile,
                location,
            };
        },
        get isActive() {
            return self.viewStore.selectedPageModel === self;
        },
        get isReady() {
            return self.sessionStore.hasFetchedSession;
        },
    }))
    .actions(self => ({
        afterCreate() {
            // Ensure our existing profile details are available
            addDisposer(self, reaction(
                () => self.isActive,
                (value) => {
                    if (value) {
                        self.sessionStore.fetchSession();
                    }
                },
                { name: 'Profile Details fetchSession on active', fireImmediately: true },
            ));
        },
        submit: flow(function* ({ location, ...values }) {
            // Do not attempt to update email, it is read-only.
            const newProfileValues = omit(values, [
                'email-input',
            ]);

            self.clearStatuses();

            // Convert from CityInput value to Address.
            const homeAddress = location
                ? {
                    city: location.name,
                    province: location.province?.code,
                }
                : undefined;

            try {
                // Currently we have them named the same way the profile keys are structured.
                yield self.sessionStore.pushProfileUpdate({
                    ...newProfileValues,
                    homeAddress,
                });
                self.hasSuceeded = true;
            } catch {
                // Error is noticed in pushProfileUpdate
                self.hasError = true;
            }
        }),
        clearStatuses() {
            self.hasSuceeded = false;
            self.hasError = false;
        },
    }));

export default ProfileDetails;
